/*=========================================================================================
  File Name: moduleCalendarGetters.js
  Description: Calendar Module Getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  getAttendMiss: state => (Id) => state.attendMissDatas.find((miss) => miss.user_id == Id),
  getAttendLate: state => (Id) => state.attendLateDatas.find((late) => late.user_id == Id),
  getAttendDay: state => (day) => state.attendDays.find((attend) => attend.day_time.toLowerCase().includes(day.toLowerCase())),
}
